export default {"src":"/_next/static/media/event-deco-2.e7dca404.svg","height":351,"width":456};